/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */

export { isSuccess } from './core/isSuccess';
export { OpenAPI } from './core/OpenAPI';

export { ApiError } from './models/ApiError';
export { ArtworkDto } from './models/ArtworkDto';
export { AuthCredentialsDto } from './models/AuthCredentialsDto';
export { BlockchainAccountDto } from './models/BlockchainAccountDto';
export { ChangePasswordRequest } from './models/ChangePasswordRequest';
export { CloneArtworkRequest } from './models/CloneArtworkRequest';
export { ContactArtistRequest } from './models/ContactArtistRequest';
export { CreatePaymentRequest } from './models/CreatePaymentRequest';
export { CreateUserRequest } from './models/CreateUserRequest';
export { EditionDto } from './models/EditionDto';
export { FavoriteRequest } from './models/FavoriteRequest';
export { LoginRequest } from './models/LoginRequest';
export { MetadataDto } from './models/MetadataDto';
export { NewArtworkRequest } from './models/NewArtworkRequest';
export { PaginatedArtworkDto } from './models/PaginatedArtworkDto';
export { PaymentDto } from './models/PaymentDto';
export { RequestDto } from './models/RequestDto';
export { ResetPasswordRequest } from './models/ResetPasswordRequest';
export { TransferArtworkRequest } from './models/TransferArtworkRequest';
export { UpdateArtworkRequest } from './models/UpdateArtworkRequest';
export { UpdateUserRequest } from './models/UpdateUserRequest';
export { UploadFileResponse } from './models/UploadFileResponse';
export { UserDto } from './models/UserDto';

export { AdminService } from './services/AdminService';
export { ArtworkService } from './services/ArtworkService';
export { AuthenticateService } from './services/AuthenticateService';
export { ImageService } from './services/ImageService';
export { MetadataService } from './services/MetadataService';
export { PaymentService } from './services/PaymentService';
export { UserService } from './services/UserService';



// WEBPACK FOOTER //
// ./src/services/openapi/generated/index.ts